(function (window, document, $) {
    'use strict';

    const sourceLanguage = 'nl';
    const supportedLanguages = ['nl', 'en', 'de', 'fr'];
    let customDropdownInitialized = false;
    let translateWidgetInitialized = false;
    let pendingLanguage = null;
    let boundTranslateElement = null;
    let widgetObserver = null;
    let translationStateObserver = null;

    window.googleTranslateElementInit = function () {
        setupCustomDropdown();

        const translateContainer = document.getElementById('google_translate_element');
        if (!translateContainer || translateWidgetInitialized || !window.google || !google.translate) {
            return;
        }

        try {
            new google.translate.TranslateElement({
                pageLanguage: sourceLanguage,
                includedLanguages: supportedLanguages.join(','),
            }, 'google_translate_element');
            translateWidgetInitialized = true;
            connectTranslateElement();
        } catch (error) {
            console.warn('Google Translate kon niet worden geinitialiseerd.', error);
        }
    };

    function setupCustomDropdown() {
        if (customDropdownInitialized || !$('.langSwitcher').length) {
            return;
        }

        customDropdownInitialized = true;

        $(document)
            .off('click.gpTranslator', '.langSwitcher .dropdown-item')
            .on('click.gpTranslator', '.langSwitcher .dropdown-item', handleLanguageSelection);

        startWidgetObserver();
        startTranslationStateObserver();
        connectTranslateElement();
        syncCustomDropdown();
    }

    function handleLanguageSelection(event) {
        event.preventDefault();

        const selectedLanguage = String($(this).data('lang') || '');
        const dropdownToggle = $(this).closest('.dropdown').find('.dropdown-toggle')[0];

        hideBootstrapDropdown(dropdownToggle);

        if (supportedLanguages.indexOf(selectedLanguage) === -1) {
            return;
        }

        pendingLanguage = selectedLanguage;
        applyPendingLanguage();
    }

    function startWidgetObserver() {
        const translateContainer = document.getElementById('google_translate_element');
        if (!translateContainer || widgetObserver) {
            return;
        }

        widgetObserver = new MutationObserver(function () {
            connectTranslateElement();
        });

        widgetObserver.observe(translateContainer, {
            childList: true,
            subtree: true,
        });
    }

    function startTranslationStateObserver() {
        if (translationStateObserver) {
            return;
        }

        translationStateObserver = new MutationObserver(function () {
            syncCustomDropdown();
        });

        translationStateObserver.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['class'],
        });
    }

    function connectTranslateElement() {
        const translateElement = getTranslateElement();
        if (!translateElement) {
            return false;
        }

        if (boundTranslateElement !== translateElement) {
            if (boundTranslateElement) {
                $(boundTranslateElement).off('change.gpTranslator');
            }

            boundTranslateElement = translateElement;
            $(boundTranslateElement).on('change.gpTranslator', function () {
                window.setTimeout(syncCustomDropdown, 0);
            });
        }

        if (pendingLanguage) {
            applyPendingLanguage();
        } else {
            syncCustomDropdown();
        }

        return true;
    }

    function getTranslateElement() {
        return document.querySelector('#google_translate_element .goog-te-combo');
    }

    function applyPendingLanguage() {
        if (!pendingLanguage) {
            return false;
        }

        if (pendingLanguage === sourceLanguage) {
            return restoreOriginalLanguage();
        }

        const translateElement = getTranslateElement();
        if (!translateElement || !hasLanguageOption(translateElement, pendingLanguage)) {
            return false;
        }

        const selectedLanguage = pendingLanguage;
        pendingLanguage = null;
        translateElement.value = selectedLanguage;
        translateElement.dispatchEvent(new Event('change', { bubbles: true }));
        updateCustomDropdown(selectedLanguage);

        return true;
    }

    function restoreOriginalLanguage() {
        if (!isTranslated()) {
            pendingLanguage = null;
            updateCustomDropdown(sourceLanguage);
            return true;
        }

        const translateElement = getTranslateElement();
        if (translateElement && hasLanguageOption(translateElement, sourceLanguage)) {
            translateElement.value = sourceLanguage;
            translateElement.dispatchEvent(new Event('change', { bubbles: true }));
            window.setTimeout(function () {
                if (pendingLanguage === sourceLanguage && isTranslated()) {
                    clickGoogleRestoreControl();
                } else {
                    syncCustomDropdown();
                }
            }, 150);
            return true;
        }

        return clickGoogleRestoreControl();
    }

    function clickGoogleRestoreControl() {
        const bannerFrames = document.querySelectorAll(
            'iframe.goog-te-banner-frame, iframe.VIpgJd-ZVi9od-ORHb-OEVmcd'
        );

        for (let index = 0; index < bannerFrames.length; index += 1) {
            try {
                const bannerDocument = bannerFrames[index].contentDocument || bannerFrames[index].contentWindow.document;
                if (!bannerDocument) {
                    continue;
                }

                const restoreControl = bannerDocument.querySelector(
                    'button[id*="restore" i], .goog-te-button button, [aria-label="Show original" i], [aria-label="Origineel weergeven" i], .goog-close-link, img[alt="Close" i]'
                );

                if (restoreControl) {
                    const clickableControl = restoreControl.closest('button, a') || restoreControl;
                    clickableControl.click();
                    window.setTimeout(syncCustomDropdown, 0);
                    return true;
                }
            } catch (error) {
                // Een cross-origin banner kan niet vanuit de pagina worden bediend.
            }
        }

        if (window.google &&
            google.translate &&
            google.translate.TranslateElement &&
            typeof google.translate.TranslateElement.getInstance === 'function') {
            const translateInstance = google.translate.TranslateElement.getInstance();
            if (translateInstance && typeof translateInstance.showOriginalText === 'function') {
                translateInstance.showOriginalText();
                window.setTimeout(syncCustomDropdown, 0);
                return true;
            }
        }

        console.warn('De oorspronkelijke taal kon niet via Google Translate worden hersteld.');
        return false;
    }

    function hasLanguageOption(translateElement, language) {
        return Array.prototype.some.call(translateElement.options, function (option) {
            return option.value === language;
        });
    }

    function isTranslated() {
        return document.documentElement.classList.contains('translated-ltr') ||
            document.documentElement.classList.contains('translated-rtl');
    }

    function syncCustomDropdown() {
        if (!isTranslated()) {
            if (pendingLanguage === sourceLanguage) {
                pendingLanguage = null;
            }
            updateCustomDropdown(sourceLanguage);
            return;
        }

        const translateElement = getTranslateElement();
        const currentLanguage = translateElement && supportedLanguages.indexOf(translateElement.value) !== -1
            ? translateElement.value
            : null;

        if (currentLanguage && currentLanguage !== sourceLanguage) {
            updateCustomDropdown(currentLanguage);
        }
    }

    function updateCustomDropdown(activeLanguage) {
        const dropdownItems = $('.langSwitcher .dropdown-item');
        const activeItem = dropdownItems.filter('[data-lang="' + activeLanguage + '"]').first();

        if (!activeItem.length) {
            return;
        }

        $('.langSwitcher .dropdown-toggle').html(activeItem.html());
        dropdownItems.each(function () {
            $(this).toggleClass('d-none', $(this).data('lang') === activeLanguage);
        });
    }

    function hideBootstrapDropdown(dropdownToggle) {
        if (window.bootstrap && bootstrap.Dropdown && dropdownToggle) {
            bootstrap.Dropdown.getOrCreateInstance(dropdownToggle).hide();
        }
    }

    $(setupCustomDropdown);
})(window, document, jQuery);
